import { RadioGroup } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { ButtonLink, SubmitButton } from "@/components/Interface/Button/Button";
import { CardModule } from "@/components/Layout/BaseLayouts/CardModule/CardModule";
import {
  AuthenticatorSetupFormElements,
  AuthenticatorSetupMethodsForm,
} from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/AuthenticatorSetupForm";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

import { initial2faSetupRouteByMethod } from "./utils";

export const TwoFactorInitialSetupForm = () => {
  const { t } = useTranslation();
  const { handleSubmit, watch, setValue } =
    useForm<AuthenticatorSetupMethodsForm>({
      // This form is only reached while 2FA is disabled (STANDARD), so that's
      // the correct preselected option.
      defaultValues: { type: ChangeTwoFactorAuthenticationMethod.STANDARD },
    });
  const navigate = useNavigate();

  const onSubmit = (data: AuthenticatorSetupMethodsForm) => {
    if (data.type) {
      navigate(initial2faSetupRouteByMethod[data.type]);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CardModule
        stickyHeader
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <ButtonLink
              variant="secondary"
              size="sm"
              to={portalRoutes.user.security.base}
            >
              {t("Common.label.cancel")}
            </ButtonLink>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("Common.label.continue")}
            />
          </>
        }
      >
        <RadioGroup
          className="flex flex-col gap-4"
          value={watch("type")}
          onChange={(type: ChangeTwoFactorAuthenticationMethod | null) =>
            setValue("type", type)
          }
          aria-label={t("portal:user-account.security.2fa.initialSetup.title")}
        >
          <AuthenticatorSetupFormElements />
        </RadioGroup>
      </CardModule>
    </form>
  );
};
